import { render, staticRenderFns } from "./provider-issuecertificates-step1.vue?vue&type=template&id=08c8a08c"
import script from "./provider-issuecertificates-step1.vue?vue&type=script&lang=js"
export * from "./provider-issuecertificates-step1.vue?vue&type=script&lang=js"
import style0 from "./provider-issuecertificates-step1.vue?vue&type=style&index=0&id=08c8a08c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports